"use client";
/*
 * Documentation:
 * DC_Media_VideoEmbed — https://app.subframe.com/4f62853ee923/library?component=DC_Media_VideoEmbed_5d976ed3-372e-4aab-ae0a-4eccaf97bf44
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_Media_VideoEmbedRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  noContainer?: boolean;
  text?: React.ReactNode;
  consent?: React.ReactNode;
  className?: string;
}

const Dc_Media_VideoEmbedRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Media_VideoEmbedRootProps
>(function Dc_Media_VideoEmbedRoot(
  {
    children,
    noContainer = false,
    text,
    consent,
    className,
    ...otherProps
  }: Dc_Media_VideoEmbedRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/5d976ed3 flex w-full flex-col items-start justify-center gap-4 rounded-md bg-neutral-50 px-4 py-4 relative",
        { "bg-transparent px-0 py-0": noContainer },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex w-full flex-col items-center justify-end gap-4 relative">
        <div className="flex w-full flex-col items-center gap-4 px-4 py-4 absolute z-[1]">
          {consent ? (
            <div className="flex w-full items-start justify-center gap-4 rounded-lg bg-neutral-50 px-4 py-4">
              {consent}
            </div>
          ) : null}
        </div>
        {children ? (
          <div className="flex w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-md z-0">
            {children}
          </div>
        ) : null}
      </div>
      {text ? (
        <span className="w-full text-caption font-caption text-default-font">
          {text}
        </span>
      ) : null}
    </div>
  );
});

export const Dc_Media_VideoEmbed = Dc_Media_VideoEmbedRoot;
